import { useState } from "react";
import { UploadCloud, X } from "lucide-react";
import { toast } from "sonner";

const fits = (f, accept) => {
  if (!accept) return true;
  const name = f.name.toLowerCase();
  return accept.split(",").map((a) => a.trim().toLowerCase()).some((a) =>
    a.startsWith(".") ? name.endsWith(a) : a.endsWith("/*") ? (f.type || "").startsWith(a.slice(0, -1)) : f.type === a);
};

export default function FileDrop({ accept, multiple = false, files = [], onFiles, hint, testid = "file-drop" }) {
  const [over, setOver] = useState(false);
  const take = (list) => {
    const all = [...(list || [])];
    const f = all.filter((x) => fits(x, accept));
    if (f.length < all.length) toast.error("That File Type Isn't Accepted Here");
    if (!f.length) return;
    onFiles(multiple ? [...files, ...f] : [f[0]]);
  };
  return (
    <div className="space-y-2">
      <label
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); take(e.dataTransfer.files); }}
        className={`flex cursor-pointer flex-col items-center justify-center gap-1.5 rounded-lg border-2 border-dashed px-4 py-6 text-center transition-colors ${over ? "border-primary bg-primary/5" : "border-slate-300 bg-slate-50/60 hover:border-primary/60"}`}
        data-testid={testid}
      >
        <UploadCloud className="h-6 w-6 text-primary" />
        <span className="text-sm font-semibold text-slate-700">Drop File{multiple ? "s" : ""} Here Or Click To Choose</span>
        {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
        <input type="file" accept={accept} multiple={multiple} className="hidden" onChange={(e) => { take(e.target.files); e.target.value = ""; }} data-testid={`${testid}-input`} />
      </label>
      {files.length > 0 && (
        <ul className="space-y-1" data-testid={`${testid}-list`}>
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} className="flex items-center justify-between gap-2 rounded-md border border-border bg-white px-2.5 py-1.5 text-xs">
              <span className="truncate font-mono text-slate-700">{f.name}</span>
              <button type="button" onClick={() => onFiles(files.filter((_, k) => k !== i))} className="text-slate-400 hover:text-red-600" aria-label="Remove File" data-testid={`${testid}-remove-${i}`}><X className="h-3.5 w-3.5" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
